export default {
  meta: {
    title: '推荐模型',
  },
};
